import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Square-root radical (√). The path traces the conventional radical
 *  shape — short tick at the lower-left, descend into the V notch,
 *  rise to the top of the radicand bar, then a horizontal vinculum
 *  extending to the right. The trailing tick at the right end keeps
 *  the glyph from looking like a generic check-mark when it scales
 *  down to 14px. */
export function IcnSquareRoot(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="square-root">
      <path d="M2 9 L4 9 L6.5 13.5 L9.5 2.5 L14 2.5" />
      <path d="M14 2.5 V4" />
    </Svg>
  );
}
